import request from '@/utils/request'

export function getDataOrder(data) {
  return request({
    url: 'Api/brand.Order/orderList',
    method: 'post',
    data
  })
}

export function getOrderDetail(data) {
  return request({
    url: 'Api/brand.Order/orderDetail',
    method: 'post',
    data
  })
}

export function exportOrder(data) {
  return request({
    url: '/Api/brand.Order/downOrder',
    method: 'post',
	responseType:'blob', 
    data
  })
}

export function getRefundList(data) {
  return request({
    url: '/Api/brand.RefundOrder/refundList',
    method: 'post',
    data
  })
}

export function getRefundDetail(data) {
  return request({
    url: '/Api/brand.RefundOrder/refundDetail',
    method: 'post',
    data
  })
}

export function allowApply(data) {
  return request({
    url: '/Api/brand.RefundOrder/allowApply',
    method: 'post',
    data
  })
}
export function changeNote(data) {
  return request({
    url: '/Api/brand.Order/updateAdminNote',
    method: 'post',
    data
  })
}
export function refuseApply(data) {
  return request({
    url: 'Api/brand.RefundOrder/refuseApply',
    method: 'post',
    data
  })
}

export function refundOrder(data) {
  return request({
    url: '/Api/brand.OrderRefund/refund',
    method: 'post',
    data
  })
}

export function getNewReturnInfo(data) {
  return request({
    url: 'Api/brand.RefundOrder/getNewReturnInfo',
    method: 'post',
    data
  })
}

export function downloadMuban(data) {
  return request({
    url: 'Api/brand.Order/downloadShippingExcel',
    method: 'post',
	responseType:'blob', 
    data
  })
}
export function downloadResult(data) {
  return request({
    url: 'Api/brand.Order/downloadImportResult',
    method: 'post',
	responseType:'blob', 
    data
  })
}
export function getShippingOrder(data) {
  return request({
    url: 'Api/brand.Order/shipping_order',
    method: 'post',
    data
  })
}
export function uploadExcel(data) {
  return request({
    url: 'Api/brand.Order/importShippingExcel',
    method: 'post',
	responseType:'blob', 
    data
  })
}
export function settlement(data) {
  return request({
    url: 'Api/brand.settlement/index',
    method: 'post',
    data
  })
}

